import { AssessmentCategory } from "@/Contracts/Assessments";
import { DocumentType } from "@/Contracts/Documents";
import { HealthStatusCategory } from "@/Contracts/QBR";
import { getQueryParamAuthDetails } from "@/Contracts/Utils";
import { cache } from "@/Contracts";

export const updateAllBlocks = (
	categoryName: string,
	documentType: DocumentType,
	categoryList: AssessmentCategory[] | HealthStatusCategory[]
) => {
	if (
		[DocumentType.SALES_PRESENTATION, DocumentType.ASSESSMENT].includes(
			documentType
		)
	) {
		const categoryToBeUpdated = (categoryList as AssessmentCategory[]).find(
			category => category.issue_type === categoryName
		);
		const shouldUpdateAllBlocks =
			!categoryToBeUpdated?.manual_assessment_data_list ||
			categoryToBeUpdated?.manual_assessment_data_list?.length === 0;

		return shouldUpdateAllBlocks;
	} else {
		const categoryToBeUpdated = (
			categoryList as HealthStatusCategory[]
		).find(category => category.name === categoryName);
		const shouldUpdateAllBlocks =
			!categoryToBeUpdated?.sub_category_list ||
			categoryToBeUpdated?.sub_category_list?.length === 0;
		return shouldUpdateAllBlocks;
	}
};

export const getDocumentPinCache = (
	documentId: string
): Record<"pin-session", string> => {
	const queryParamAuthDetails = getQueryParamAuthDetails();
	const searchParam = new URLSearchParams(queryParamAuthDetails?.queryParam);
	const id = searchParam.get("user_id") || searchParam.get("client_user_id");

	const cachePinSession = cache.get(`${documentId}::${id}`, true);

	const customHeaders = {
		"pin-session": cachePinSession
	};

	return customHeaders;
};
